<template src="./tendenze.html"></template>

<script>
import calendar from "@/components/ui/Calendar";
import DialogExClienti from "@/components/dialog/statistiche/DialogExClienti.vue";

import { get_tendenze, get_tendenze_dett } from "@/api/api.statistiche.js";

export default {
  components: {
    calendar,
    DialogExClienti,
  },

  props: {
    caricaDatiTendenze: { type: Boolean, default: false },
    cont: { type: Number, default: 0 }
  },

  data: () => ({
    search: "",
    attesa: false,
    datiEsposizioni: [],
    headersEsposizioni: [],
    esposizioniStampa: [],
    headersDatiEsposizioni: [],
    totaleEsposisioni: {},

    dialogPopExpo: false,
    dialogPDF: false,
    elencoPopExpo: [],
    valore: "CLRAGSOC", //colonna di ordinamento corrente della tabella dettaglio tendenze
    ordDesc: false, //ordinamento descrescente
    sortBy: 'CLRAGSOC',
    sortDesc: false,

    annoSel: 2018,
    dataChange: true,
    date: {
      dataDa1: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
      dataA1: new Date().toISOString().substr(0, 10),

      dataDa2: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
      dataA2: new Date().toISOString().substr(0, 10),
    },

    riepilogoConfronto: [],
    dialogExClienti: false,
    filtroExClienti: "",
    numeroExClienti: 0,

    dialogDataInizio1: false,
    dialogDataFine1: false,
    dialogDataInizio2: false,
    dialogDataFine2: false,
    dataSelIT1: new Date().toISOString().substr(0, 10),
    dataSelIT2: new Date().toISOString().substr(0, 10),
    dataSelIT3: new Date().toISOString().substr(0, 10),
    dataSelIT4: new Date().toISOString().substr(0, 10),

    page: 1,
    pageCount: 0,
    itemsPerPage: 9999,
  }),

  methods: {
    async caricaDati() {
      this.attesa = true;
      this.datiEsposizioni.Riepilogo = [];
      //this.totaleEsposisioni = {};
      this.headersEsposizioni = [{ text: "", value: "", width: "180" }];
      let par = "riepilogo/dati?anno=" + this.annoSel;
      if (this.userSwitch.Codice != undefined)
        par += "&idAgente=" + this.userSwitch.Codice;
      else if (this.$store.getters["user/getCodice"])
        par += "&idAgente=" + this.$store.getters["user/getCodice"];
      else if (this.role == "Admin") par += "&idAgente=0";

      //carico i dati del riepilogo della prima tabella
      let res = await get_tendenze(par);
      if (res.data == null || res.data == undefined) {
        this.$toast.alert("Errore! Impossibile caricare i dati");
        this.datiEsposizioni.Riepilogo = [];
        this.headersEsposizioni = [];
        return;
      }
      //salvo i dati del riepilogo (prima tabella)
      this.datiEsposizioni.Riepilogo = res.data;
      this.datiEsposizioni.Riepilogo.forEach((el) => {
        this.headersEsposizioni.push({
          text: el.Anno,
          value: el.Anno,
        });
      });
      this.esposizioniStampa = [""];

      //carico i dati del dettaglio delle esposizioni
      /* if (
        this.date.dataDa1 != this.date.dataDa2 ||
        this.date.dataA1 != this.date.dataA2
      ) */
      this.aggiornaDettaglioEsp();

      this.attesa = false;
    },

    /* tabella nuove esposizioni */
    async aggiornaDettaglioEsp() {
      this.attesa = true;
      let par = "dettaglio/dati";
      if (this.userSwitch.Codice != undefined)
        par += "?idAgente=" + this.userSwitch.Codice;
      else if (this.$store.getters["user/getCodice"])
        par += "?idAgente=" + this.$store.getters["user/getCodice"];
      else if (this.role == "Admin") par += "?idAgente=0";

      if (
        this.date.dataA1 < this.date.dataDa1 ||
        this.date.dataA2 < this.date.dataDa2
      )
        return;
      let res = await get_tendenze_dett(par, this.date);
      this.datiEsposizioni.Dettaglio = res.data;

      //salvo i totali della tabella da visualizzare in fondo
      let totale = this.totaleEsposisioni;
      this.datiEsposizioni.Dettaglio.filter(function (dett) {
        if (dett.CLRAGSOC != "zzzzz") return dett;
        else totale = dett;
      });
      this.totaleEsposisioni = totale;
      this.dataChange = false;
      this.attesa = false;
      this.caricaDatiConfronto(par);
      this.aggiornaHeadersEsp();
    },

    async caricaDatiConfronto() {
      let par = "/riepilogo/dati";
      if (this.userSwitch.Codice != undefined)
        par += "?idAgente=" + this.userSwitch.Codice;
      else if (this.$store.getters["user/getCodice"])
        par += "?idAgente=" + this.$store.getters["user/getCodice"];
      else if (this.role == "Admin") par += "?idAgente=0";

      let res = await get_tendenze_dett(par, this.date);
      this.riepilogoConfronto = res.data;
    },
    //NOTA: TODO: se metto la funzione nella computed non funziona
    getDatiEsposizioni() {
      if (
        this.datiEsposizioni.Dettaglio == null ||
        this.datiEsposizioni.Dettaglio == undefined ||
        this.datiEsposizioni.Dettaglio.length <= 0
      )
        return;
      let elenco = [];
      this.datiEsposizioni.Dettaglio.forEach((el) => {
        elenco.push(el);
      });

      switch (this.valore) {
        case "CLRAGSOC":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.CLRAGSOC.toLowerCase() < b.CLRAGSOC.toLowerCase() ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.CLRAGSOC.toLowerCase() > b.CLRAGSOC.toLowerCase() ? 1 : -1
            );
          break;
        case "PorteVendute":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.PorteVendute < b.PorteVendute ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.PorteVendute > b.PorteVendute ? 1 : -1
            );
          break;
        case "PorteInExpo":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.PorteInExpo < b.PorteInExpo ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.PorteInExpo > b.PorteInExpo ? 1 : -1
            );
          break;
        case "Fatturato":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.Fatturato) < parseFloat(b.Fatturato) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.Fatturato) > parseFloat(b.Fatturato) ? 1 : -1
            );
          break;
        case "RagSoc":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() < b.RagSoc.toLowerCase() ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.RagSoc.toLowerCase() > b.RagSoc.toLowerCase() ? 1 : -1
            );
          break;
        case "Quantita":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              a.Quantita < b.Quantita ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              a.Quantita > b.Quantita ? 1 : -1
            );
          break;

        case "FatturatoPromo":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoPromo) < parseFloat(b.FatturatoPromo) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoPromo) > parseFloat(b.FatturatoPromo) ? 1 : -1
            );
          break;

        case "FatturatoDiff":
          if (this.ordDesc)
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoDiff) < parseFloat(b.FatturatoDiff) ? 1 : -1
            );
          else
            elenco = elenco.sort((a, b) =>
              parseFloat(a.FatturatoDiff) > parseFloat(b.FatturatoDiff) ? 1 : -1
            );
          break;
        default:
          break;
      }
      return elenco;
    },

    aggiornaHeadersEsp() {
      this.headersDatiEsposizioni = [
        { text: "Nuove Esposizioni", value: "CLRAGSOC", sortable: true },
        {
          text: "N. porte vendute",
          value: "PorteVendute",
          sortable: true,
          style: "background-color: #f2f2f2;",
        },
        {
          text: "N. porte in expo",
          value: "PorteInExpo",
          sortable: true,
          style: "background-color: #f2f2f2;",
        },
        {
          text: "Fatturato",
          value: "Fatturato",
          sortable: true,
          style: "background-color: #f2f2f2;",
        },
        {
          text: "N. porte vendute",
          value: "PorteVendute2",
          sortable: true,
          style: "background-color: #cde1f4;",
        },
        {
          text: "N. porte in expo",
          value: "PorteInExpo2",
          sortable: true,
          style: "background-color: #cde1f4;",
        },
        {
          text: "Fatturato",
          value: "Fatturato2",
          sortable: true,
          style: "background-color: #cde1f4;",
        },
        { text: "Pop (Si/No)", value: "Pop" },
        { text: "PDF", value: "" },
      ];
    },

    //TODO ordinamento tabella
    /* ordinaTabellaEsp(item) {
      if (item == null || item == undefined) return;
      if (!item.sortable) return;

      if (this.valore == item.value) this.ordDesc = !this.ordDesc; //se clicco un'altra volta sulla colonna inverte l'ordinamento
      this.valore = item.value;
    }, */

    ordinaTabellaEsp(column) {
      // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
        this.sortBy = column;
        this.sortDesc = false;
      }
    },

    apriDettaglioPop(expo) {
      if (!expo.Pop) return;
      this.elencoPopExpo = expo.ElencoPop;
      this.dialogPopExpo = true;
    },

    apriDettaglioExpo(expo, confronto) {
      if (expo.PorteInExpo <= 0 && !confronto) return;
      if (expo.PorteInExpo2 <= 0 && confronto) return;

      this.elencoPopExpo = confronto ? expo.PorteExpo2 : expo.PorteExpo;
      this.dialogPopExpo = true;
    },

    chiudiDettaglioPop() {
      this.elencoPopExpo = [];
      this.dialogPopExpo = false;
    },

    close() {
      this.dialogPDF = false;
    },

    CambioData() {
      if (!this.dataChange) this.dataChange = true;
    },

    apriDialogSceltaFile(file) {
      if (file.length >= 1) this.apriPdf(file[0].Percorso);
    },

    apriPdf(file) {
      //apro il file pdf della promo
      window.open(file, "_blank");
    },

    openDialogExClienti(filtro, num) {
      if (this.role != "Admin") {
        this.dialogExClienti = false;
        return;
      }
      this.filtroExClienti = filtro;
      this.numeroExClienti = num;
      this.dialogExClienti = true;
    },

    chiudiDialogExClienti() {
      this.dialogExClienti = false;
      this.filtroExClienti = "";
    },

    verificaPeriodi() {
      this.setDate();//setto le text-field delle date
      if (this.date.dataDa1 >= this.date.dataA1) return false;
      if (this.date.dataDa2 >= this.date.dataA2) return false;
      if (this.date.dataA1 == this.date.dataA2 && this.date.dataDa1 == this.date.dataDa2)
        return false;
      return true;
    },

    setDate() {
      let datada = new Date(this.date.dataDa1);
      datada.setDate(datada.getDate()); //formato system
      datada = this.$i2kFunctions.formatDate_IT(datada); //dd/MM//YYYY;
      this.dataSelIT1 = datada;

      let dataa = new Date(this.date.dataA1);
      dataa.setDate(dataa.getDate()); //formato system
      dataa = this.$i2kFunctions.formatDate_IT(dataa); //dd/MM//YYYY;
      this.dataSelIT2 = dataa;

      let datada2 = new Date(this.date.dataDa2);
      datada2.setDate(datada2.getDate()); //formato system
      datada2 = this.$i2kFunctions.formatDate_IT(datada2); //dd/MM//YYYY;
      this.dataSelIT3 = datada2;

      let dataa2 = new Date(this.date.dataA2);
      dataa2.setDate(dataa2.getDate()); //formato system
      dataa2 = this.$i2kFunctions.formatDate_IT(dataa2); //dd/MM//YYYY;
      this.dataSelIT4 = dataa2;
    },
  },

  async mounted() {
    this.verificaPeriodi();
    await this.caricaDati();
  },

  computed: {
    userSwitch() {
      return this.$store.getters["user/getUserSwitch"];
    },

    role() {
      return this.$store.getters["user/getRole"];
    },
  },

  watch: {
    caricaDatiTendenze() {
      if (this.caricaDatiTendenze) {
        this.caricaDati();
        this.$emit("tendenzeCaricate");
      }
    },

    cont(newVal) {
      if (newVal) this.caricaDati();
    },

    dialogPopExpo(newVal) {
      if (!newVal) this.chiudiDettaglioPop();
    },
  },
};
</script>

<style scoped>
.cellaHeader {
  border: 1px solid #dddddd;
  padding: 0;
  margin: 0;
}

#headerRiepilogo {
  min-width: 16%;
  max-width: 16%;
  width: 16% !important;
}

.cellaBody {
  padding: 0.2em !important;
  margin: 0;
}

.cellaEsposizioni {
  justify-content: center;
  text-align: center;
  top: 0;
  padding: 0 !important;
  margin: 0;
}

table th {
  border: 1px solid #cbcbcb;
  font-size: 16px !important;
  font-weight: bold !important;
}

table td {
  border: 1px solid #cbcbcb;
  font-size: 15px !important;
}
</style>